import { AppParamsActions } from './../../../shared/store/app-params.reducer';
// import { CommonApiService } from './../../../shared/services/common-api.service';
import { User } from './../../../shared/services/auth.service';

import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnChanges, OnDestroy, AfterViewInit } from '@angular/core';
import { Output, EventEmitter, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IState } from './../../../shared/store/root.reducer';
import { ISearchResult, IApplicationLink, IApplicationRoutes } from 'ops-lib';
import { AuthService } from './../../../shared/services/auth.service';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { CommonApiService } from 'src/app/shared/services/commons-api.service';
import { environment } from 'src/environments/environment';


const uniq = require('lodash/uniq');
const concat = require('lodash/concat');

@Component({
  selector: 'app-smart-search-slider',
  templateUrl: './smart-search-slider.component.html',
  styleUrls: ['./smart-search-slider.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('true', style({
        transform: 'translate3d(0, 0, 0)',
        boxShadow: '0 5px 10px rgba(0,0,0,0.3)'
      })),
      state('false', style({
        transform: 'translate3d(-520px, 0, 0)',
        boxShadow: 'none'
      })),
      transition('true => false', animate('400ms ease-in-out')),
      transition('false => true', animate('400ms ease-in-out'))
    ]),
  ]
})
export class SmartSearchSliderComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  @Input() show: string;
  @Output() closeFunction: EventEmitter<string> = new EventEmitter<string>();

  // local
  appId = environment.appId;
  isLoading = false;
  results: Array<ISearchResult> = new Array<ISearchResult>();
  currentUser: User;
  features: string;
  clearResults = false;
  navigationLinks = <Array<IApplicationLink>>{};
  externalRoutes = <Array<IApplicationRoutes>>{};

  // Defaults Permissions
  AVAILABLE_SEARCH_TYPES = ['cla'];
  DISABLED_SEARCH_TYPES = ['req', 'crd', 'del'];

  // subscription
  subscriptions: Subscription[] = [];

  constructor(
    private store: Store<IState>,
    private commonsApiService: CommonApiService,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.closeFunction.emit('false');
    this.subscriptions.push(this.store.pipe(select((s: IState) => s.currentUser)).subscribe(currentUser => {
      this.currentUser = currentUser;
      this.features = currentUser.features.join(',');
    }));
    this.subscriptions.push(this.store.pipe(select((s: IState) => s.app.navigationLinks)).subscribe(links => {
      this.navigationLinks = links;
      this.buildPermissions();
    }));
    this.subscriptions.push(this.store.pipe(select((s: IState) => s.app.applicationRoutes)).subscribe(routes => {
      this.externalRoutes = routes;
    }));
  }

  ngAfterViewInit() {
    this.buildPermissions();
  }

  ngOnChanges(change) {
    if (change.show) {
      if (!change.show.firstChange) {
        this.show = change.show.currentValue;
      }
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.map(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
  buildPermissions() {
    if (this.navigationLinks) {
      if (this.navigationLinks.length > 0) {
        const valutrax_link = this.navigationLinks.find(link => link.app_feature_code === 'VALUTRAX');
        if (valutrax_link) {
          if (valutrax_link.enabled && valutrax_link.user_application_access === 1) {
            this.AVAILABLE_SEARCH_TYPES.push('cla');
            this.DISABLED_SEARCH_TYPES = this.DISABLED_SEARCH_TYPES.filter(types => types !== 'cla');
          }
        }
        const backtrax_link = this.navigationLinks.find(link => link.app_feature_code === 'RTRN_VW_UI');
        if (backtrax_link) {
          if (backtrax_link.enabled && backtrax_link.user_application_access === 1) {
            this.AVAILABLE_SEARCH_TYPES.push('crd');
            this.DISABLED_SEARCH_TYPES = this.DISABLED_SEARCH_TYPES.filter(types => types !== 'crd');
          }
        }
      }
    }

  }
  close() {
    this.closeFunction.emit('false');
    this.isLoading = false;
    this.clearResults = true;
  }
  clear() {
    this.isLoading = false;
    this.clearResults = true;
  }
  onSearch(criteria: string) {
    if (criteria.length > 0) {
      this.isLoading = true;
      this.results = new Array<ISearchResult>();

      const obsevableSearchs: any[] = [];
      this.AVAILABLE_SEARCH_TYPES.map(type =>  {
        obsevableSearchs.push(
          this.commonsApiService.Search({ type: type, criteria: criteria, features: this.features, from: null, to: null })
        );
      });
      forkJoin(obsevableSearchs).subscribe(results => {
        results.map(res => {
          this.results = uniq(concat(this.results, res));
        });
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
      this.results = [];
    }
  }

  onResultClick(result: ISearchResult) {
    if (this.appId === result.applicationId) {
      this.closeFunction.emit('false');
      this.isLoading = false;
      this.clearResults = true;
      this.store.dispatch({
        type: AppParamsActions.SET_ID,
        payload: result.identifier
      });
      this.router.navigate(['claim-detail']);
    } else {
      this.clearResults = true;
      const app = this.navigationLinks.find(l => l.app_id === result.applicationId);
      if (app) {
        const appRoute = this.externalRoutes
          .find(r => r.applicationId === result.applicationId &&
            r.searchType === result.searchType);
        if (appRoute) {
          const parameters = JSON.stringify({ 'id': result.identifier });
          this.authService.redirect(appRoute.route, parameters, app.url.toString())
            .subscribe(res => {
              this.closeFunction.emit('false');
              window.open(res, '_blank');
            });
        }

      }
    }
  }
}
